import { render, staticRenderFns } from "./QuotationListGarantia.vue?vue&type=template&id=93507830"
import script from "./QuotationListGarantia.vue?vue&type=script&lang=js"
export * from "./QuotationListGarantia.vue?vue&type=script&lang=js"
import style0 from "./QuotationListGarantia.vue?vue&type=style&index=0&id=93507830&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports